import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isDesktopNavOpen: true,
  tabs: {
    mdfAdmissionRequestSummaryDetail: 0,
    carryRequestSummaryDetail: 0,
    admissionPersonDetails: 0,
    authGroupDetails: 0
  }
};

const slice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setDesktopNavOpen(state) {
      state.isDesktopNavOpen = !state.isDesktopNavOpen;
    },
    setTab(state, action) {
      const { tabViewName, index } = action.payload;
      state.tabs[tabViewName] = index;
    }
  }
});

export const reducer = slice.reducer;

export const setDesktopNavOpen = () => (dispatch) => {
  dispatch(slice.actions.setDesktopNavOpen());
};

export const setTab =
  ({ tabViewName, index }) =>
  (dispatch) => {
    dispatch(slice.actions.setTab({ tabViewName, index }));
  };

export default slice;
